import { Mail, Phone, User } from "lucide-react";

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#F9F8F6]" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">Get in touch</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              Speak directly with our Community Liaison Officer.
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-[#2A2B2A]/85">
              Frank is your dedicated point of contact for the project — call,
              email or come and meet him at one of the information days. He’ll
              answer any questions and pass them on to the rest of the team.
            </p>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <div className="bg-white border border-[#E0DCD3] rounded-sm p-8 lg:p-10">
              <div className="flex items-start gap-4 mb-7">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm bg-[#F2EFE8] border border-[#E0DCD3]">
                  <User className="h-5 w-5 text-[#3A4B3A]" strokeWidth={1.8} />
                </span>
                <div>
                  <div className="text-[11px] tracking-[0.18em] uppercase font-semibold text-[#CBA365]">Community Liaison Officer</div>
                  <div className="font-serif-display text-2xl tracking-tight mt-1">Frank Donnelly</div>
                  <div className="text-[13px] text-[#63635E] mt-1">Loughrea Energy Ltd.</div>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <a
                  href="mailto:nre@obton.com"
                  data-testid="contact-email"
                  className="group flex items-center gap-3 p-4 rounded-sm border border-[#E0DCD3] hover:border-[#3A4B3A] transition-colors"
                >
                  <Mail className="h-4 w-4 text-[#3A4B3A]" />
                  <div>
                    <div className="text-[11px] text-[#63635E]">Email</div>
                    <div className="text-[14px] font-medium link-underline">nre@obton.com</div>
                  </div>
                </a>
                <a
                  href="tel:+353873547360"
                  data-testid="contact-phone"
                  className="group flex items-center gap-3 p-4 rounded-sm border border-[#E0DCD3] hover:border-[#3A4B3A] transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#3A4B3A]" />
                  <div>
                    <div className="text-[11px] text-[#63635E]">Phone</div>
                    <div className="text-[14px] font-medium link-underline">087‑354 7360</div>
                  </div>
                </a>
              </div>

              <p className="mt-7 text-[12.5px] text-[#63635E] leading-relaxed">
                For media enquiries or formal submissions in advance of the planning application,
                please use the message form above so we can route your enquiry to the right person.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
